var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestEndorsements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M27.704 14.255a.97.97 0 0 0-.97.97 15.39 15.39 0 0 1-11.53 14.593 1.367 1.367 0 0 0-.28 0 15.39 15.39 0 0 1-11.53-14.594V8.213l11.636-5.41 5.557 2.579a.972.972 0 1 0 .814-1.765L15.476.853a.97.97 0 0 0-.824 0L2.046 6.672a.97.97 0 0 0-.543.659c-.044.138-.06.283-.048.427V15.224A17.377 17.377 0 0 0 14.7 31.767c.122.02.246.02.368 0h.136c.074.01.149.01.223 0a17.377 17.377 0 0 0 13.246-16.552.97.97 0 0 0-.97-.96zm1.532-11.608a3.5 3.5 0 0 0-2.86-.65 4.393 4.393 0 0 0-2.57 1.62L13.76 16.485l-.592 4.567a1.62 1.62 0 0 0 .611 1.513c.279.212.62.324.97.32.23.002.458-.044.67-.136l4.15-1.745L29.575 8.136a3.879 3.879 0 0 0-.34-5.489zm-1.163 4.296l-9.736 12.45-3.17 1.34.445-3.492 9.726-12.393c.336-.487.84-.832 1.416-.97a1.532 1.532 0 0 1 1.28.263 1.94 1.94 0 0 1 .039 2.802z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestEndorsements);
export default __webpack_public_path__ + "static/media/request-endorsements.c0029dc12177bb2c6ae724ef5e1bf34c.svg";
export { ForwardRef as ReactComponent };